/* Irene Quirós · una sola oferta de bienvenida en este tema.
   Con la opción «Cerrar la ventana emergente de Klaviyo en este tema» (sección «Escenario de evaluación») activa,
   la ventana emergente de Klaviyo se cierra con su propio botón cuando termina de abrirse (mientras tanto queda
   recortada por CSS y sin interacción), de modo que solo se muestra la ventana de bienvenida del tema.
   No se modifica Klaviyo: su seguimiento, sus listas, sus flujos y sus formularios incrustados siguen funcionando,
   y los códigos «Bienvenida…» ya entregados siguen siendo válidos. */
(function () {
  'use strict';
  if (!window.IQ || !window.IQ.hideKlaviyoPopup) return;
  var SEL = '[role="dialog"][aria-label="POPUP Form"]';
  var before = null;
  document.addEventListener('focusin', function (e) {
    if (!(e.target.closest && e.target.closest(SEL))) before = e.target;
  }, true);
  function restore() {
    if (before && before.focus && document.contains(before) && before !== document.body) before.focus({ preventScroll: true });
  }
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail) return;
    if (e.detail.type === 'close') { setTimeout(restore, 50); return; }
    if (e.detail.type !== 'open') return;
    var tries = 0;
    function shut() {
      var dlg = document.querySelector(SEL);
      if (!dlg) return;
      var b = dlg.querySelector('.klaviyo-close-form');
      if (b) b.click();
      if (++tries < 4) setTimeout(shut, 1500);
    }
    /* Se espera a que termine la animación de apertura: si se cierra durante ella, Klaviyo no desmonta la ventana */
    setTimeout(shut, 1300);
  });
})();